import * as THREE from 'three';

// Charge le juke-box que tools/build-jukebox.mjs a préparé pour
// visualizers/jukebox.js : la photo éteinte, la lumière ajoutée (diff), la
// carte d'identifiants sans perte (zone, coordonnée des panneaux, tube, bras),
// les reflets de la vitre et les mesures (disque, tubes, boîte). UNE fois, au
// démarrage. Le préchargement est un POINT DE CÂBLAGE de chaque entrée (main,
// main-radio, play-boot, le harnais) ; il rend false s'il manque quoi que ce
// soit, et l'entrée retire Jukebox de la rotation (sans une des deux photos :
// indisponible).
const MANIFEST_URL = 'textures/jukebox.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' introuvable'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
function data(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.NearestFilter;
  t.magFilter = THREE.NearestFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
// les reflets : prémultipliés, lus en linéaire comme une image
function premul(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.premultiplyAlpha = false;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadJukebox() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('jukebox.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, data),
        loadTexture('textures/' + manifest.refl, premul),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], refl: parts[3], data: parts[4] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] juke-box indisponible, Jukebox est retiré', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getJukebox() {
  return _assets;
}
